module.exports = __webpack_public_path__ + "static/media/3rd_banner.6b0880bb.png";